import * as React from "react";
import type { SVGProps } from "react";
const SvgCurrencyCent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 7.54A5.97 5.97 0 0 0 12.992 6m0 0A5.996 5.996 0 0 0 7 12c0 3.314 2.682 6 5.992 6m0-12 .001-2m-.001 14a5.97 5.97 0 0 0 4.004-1.536M12.992 18l.001 2"
    />
  </svg>
);
export default SvgCurrencyCent;
